import { useEffect } from 'react';

/** Reloads at the given hour (24h, default 4am) to reset accumulated browser
 *  state on unattended TV displays. SW tile cache survives the reload. */
export function useNightlyReload(hour: number = 4): void {
  useEffect(() => {
    const now = new Date();
    const next = new Date(now);
    next.setHours(hour, 0, 0, 0);
    if (next <= now) next.setDate(next.getDate() + 1);
    const t = window.setTimeout(
      () => window.location.reload(),
      next.getTime() - now.getTime()
    );
    return () => window.clearTimeout(t);
  }, [hour]);
}
